/* eslint-disable no-param-reassign */
import { reactive } from 'vue';
import { saveQuestionType } from '../api/eventsSurveys';

export default function useQuestionTypeEditor({ questionType }) {
  const state = reactive({
    questionType: { ...questionType },
    error: false,
    savedQuestionType: '',
    projectId: '',
  });

  const handleSaveQuestionType = async ({ item }, questionTypes) => {
    try {
      const { questions, ...questionTypeToSave } = item;
      questionTypeToSave.project_id = state.projectId;
      questionTypeToSave.questions = questionType.questions;
      if (!questionTypeToSave.display_order) {
        questionTypeToSave.display_order = questionTypes.length + 1;
      }
      state.savedQuestionType = await saveQuestionType(questionTypeToSave);
    } catch (e) {
      state.error = true;
      console.log(e);
    }
  };

  return {
    state,
    handleSaveQuestionType,
  };
}
